import { REWARD_STATUS } from "../enums/RewardStatus";

export const getRewardStatusName = (status) => {
  switch (status) {
    case REWARD_STATUS.PENDING_DELIVERY:
      return "Pendiente de Entrega";
    case REWARD_STATUS.DELIVERED:
      return "Entregado";
    default:
      return "";
  }
};
